import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=780c1b1f&"
import script from "./ProductsView.vue?vue&type=script&lang=ts&"
export * from "./ProductsView.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports